var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBlueBlob = function SvgBlueBlob(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1080,
    height: 892,
    viewBox: "0 0 1080 892",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M544.51 600.458C794.104 438.442 608.51 239.958 383.099 172.622C157.688 105.286 180.642 284.365 180.642 528.911C180.642 773.458 294.915 762.474 544.51 600.458Z",
    fill: "transparent",
    fillOpacity: 0.35
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M721.34 702.514C1013.46 754.179 481.159 74.724 277.911 207.667C74.6635 340.609 -88.713 462.269 139.433 578.756C367.579 695.242 429.215 650.85 721.34 702.514Z",
    fill: "transparent",
    fillOpacity: 0.35
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#A5D2FB",
    fillOpacity: 0.15
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "20s",
    repeatCount: "indefinite",
    values: "M677.317 601.034C926.911 439.018 630.881 101.128 395.089 141.664C159.297 182.2 128.969 359.474 192.632 497.953C256.295 636.432 427.722 763.051 677.317 601.034Z;M552.509 600.458C802.104 438.442 616.51 239.958 391.099 172.622C165.688 105.286 188.642 284.365 188.642 528.911C188.642 773.458 302.915 762.474 552.509 600.458Z;M693.34 669.514C985.464 721.179 453.159 41.724 249.911 174.667C46.6635 307.609 -116.713 429.269 111.433 545.756C339.579 662.242 401.215 617.85 693.34 669.514Z;M677.317 601.034C926.911 439.018 630.881 101.128 395.089 141.664C159.297 182.2 128.969 359.474 192.632 497.953C256.295 636.432 427.722 763.051 677.317 601.034Z;"
  }))));
};
export default SvgBlueBlob;